import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'next/navigation';

import { addProductLike, deleteProductLike } from '../api';

import {
  PRODUCT_EXTENDED_BY_SLUG,
  RQ_LIKED_PRODUCTS,
} from '@/modules/ReactQuery/cacheKeys';

export const UPDATE_LIKE_TYPE = {
  ADD: 'add',
  REMOVE: 'remove',
} as const;

type UpdateType = (typeof UPDATE_LIKE_TYPE)[keyof typeof UPDATE_LIKE_TYPE];

type UpdateLikeMutationProps = {
  productId: number;
  type: UpdateType;
};

export function useUpdateProductLike({ userId }: { userId?: number }) {
  const queryClient = useQueryClient();
  const { slug } = useParams<{ slug: string }>();

  return useMutation({
    mutationFn: ({ productId, type }: UpdateLikeMutationProps) => {
      if (type === UPDATE_LIKE_TYPE.ADD) {
        return addProductLike(productId);
      }
      return deleteProductLike(productId);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [RQ_LIKED_PRODUCTS, { sellerId: userId }],
      });
      await queryClient.invalidateQueries({
        queryKey: [RQ_LIKED_PRODUCTS, userId],
      });
      await queryClient.invalidateQueries({
        queryKey: [PRODUCT_EXTENDED_BY_SLUG, slug],
        refetchType: 'inactive',
      });
    },
  });
}
